<template>
	<section v-loading="loading">
		<!-- 过滤条件 -->
		<el-form :inline="true">
			<el-form-item style="margin-right:12px">
				<el-select v-model="filters.status" filterable placeholder="选择状态" @change="search">
					<el-option v-for="item in thestatus" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-input placeholder="搜索位置" v-model="filters.keyword" @input="search" clearable></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="search">查询</el-button>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="gosend">发布盘点任务</el-button>
			</el-form-item>
		</el-form>
		<!-- 数据列表 -->
		<el-table :data="mission_list">
			<el-table-column label="盘点主题" prop="title" min-width="150"></el-table-column>
			<el-table-column label="盘点仓库" prop="stores" show-overflow-tooltip></el-table-column>
			<el-table-column label="执行时间" align="center" :formatter="startEndTimeFormatter"></el-table-column>
			<el-table-column label="发布人" prop="creator.name" align="center" show-overflow-tooltip></el-table-column>
			<el-table-column label="发布时间" prop="add_time" :formatter="addTimeFormatter" align="center"
				show-overflow-tooltip></el-table-column>
			<el-table-column label="状态" prop="status" :formatter="statusFormatter" align="center"></el-table-column>
			<!-- 操作 -->
			<el-table-column label="" width="350">
				<template slot-scope="scope">
					<el-button type="text" style="color:#007AFF;" :loading="scope.row.finish_loading"
						v-if="scope.row.status=='DOING'" @click="finish(scope.row)">完成盘点</el-button>
					<el-button type="text" style="color:#007AFF;" @click="getState(scope.row)"
						v-if="scope.row.status!='READY'&&scope.row.status!='CANCEL'">盘点详情</el-button>

					<el-button type="text" style="color:#007AFF;" @click="getDetail(scope.row)">任务说明</el-button>

					<el-button type="text" style="color:#007AFF;" :loading="scope.row.start_loading"
						v-if="scope.row.status=='READY'" @click="start(scope.row)">开启盘点</el-button>

					<el-button type="text" style="color:#007AFF;" :loading="scope.row.cancel_loading"
						v-if="scope.row.status=='DOING'" @click="cancel(scope.row)">取消盘点</el-button>

					<el-button type="text" style="color:#007AFF;" :loading="scope.row.remove_loading"
						v-if="scope.row.status=='CANCEL'||scope.row.status=='READY'" @click="remove(scope.row)">删除
					</el-button>

					<el-button type="text" style="color:#007AFF;" v-if="scope.row.status=='COMPLETE'"
						@click="getPrint(scope.row)">条码打印</el-button>

					<el-button type="text" style="color:#007AFF;" v-if="scope.row.status=='COMPLETE'"
						@click="statis(scope.row)">盘点统计</el-button>

				</template>
			</el-table-column>
		</el-table>
		<el-pagination layout="prev, pager, next" :total="totalRow" @current-change="nextPage"
			:page-size="filters.size"></el-pagination>

		<!-- 发布盘点任务表单 -->
		<Drawer placement="right" :closable="false" :mask-closable="false" v-model="mission_form.visible" width="50%">
			<div class="demo-drawer-footer1" style="width:50%">
				<el-button @click="mission_form.visible=false">关 闭</el-button>
				<el-button @click="create" type="primary" :loading="mission_form.saving">确定</el-button>
			</div>
			<el-form style="margin-top:60px" :model="mission_form.data" :rules="mission_form.rules" label-width="80px"
				ref="mission_form">
				<el-form-item label="盘点标题" prop="title">
					<el-input v-model="mission_form.data.title" placeholder="请输入标题"></el-input>
				</el-form-item>
				<div style="width:100%;background-color:#F8F8F8;height:8px"></div>
				<div style="padding:14px;background-color:white;">
					<span style="font-size:15px;color:#666666;margin-right:16px">盘点设置</span>
					<span style="font-size:15px;color:#2EB6AA;cursor:pointer;"
						@click="store_drawer.visible=true">选择位置</span>
					<el-table max-height="450" :data="shelf_configs" row-key="id" :default-expand-all="true"
						style="margin-top:15px" :tree-props="mission_form.props">
						<el-table-column prop="name" label="位置"></el-table-column>
						<el-table-column prop label="初盘人" show-overflow-tooltip>
							<template slot-scope="scope">
								<el-button type="text" @click="setChecker(scope.row,1)">
									{{scope.row.type=='store'?'批量设置':'设置'}}</el-button>
								<span
									v-if="scope.row.type=='store'">(已设置{{scope.row.list.filter(e=>e.first_checkers&&e.first_checkers.length>0).length}}处)</span>
								<span @click="setChecker(scope.row,1)"
									v-if="scope.row.type=='shelf' && scope.row.first_checkers && scope.row.first_checkers.length>0">
									({{scope.row.first_checkers.length+'人：'}}
									<span v-for="(user,ind) in scope.row.first_checkers" :key="ind"
										style="margin-right:5">{{user.user_id?user.name:''}}</span>)
								</span>
							</template>
						</el-table-column>
						<el-table-column prop label="复盘人" show-overflow-tooltip>
							<template slot-scope="scope">
								<el-button type="text" @click="setChecker(scope.row,2)">
									{{scope.row.type=='store'?'批量设置':'设置'}}</el-button>
								<span
									v-if="scope.row.type=='store'">(已设置{{scope.row.list.filter(e=>e.last_checkers&&e.last_checkers.length>0).length}}处)</span>
								<span @click="setChecker(scope.row,2)"
									v-if="scope.row.type=='shelf' && scope.row.last_checkers && scope.row.last_checkers.length>0">
									({{scope.row.last_checkers.length+'人：'}}
									<span v-for="(user,ind) in scope.row.last_checkers" :key="ind"
										style="margin-right:5">{{user.user_id?user.name:''}}</span>)
								</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div style="width:100%;background-color:#F8F8F8;height:8px"></div>
				<el-form-item style="margin-top:15px" label="开始时间" prop="start_time">
					<el-date-picker v-model="mission_form.data.start_time" type="date" placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="截止时间" prop="end_time">
					<el-date-picker v-model="mission_form.data.end_time" type="date" placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
			</el-form>
		</Drawer>

		<!-- 仓库选择 -->
		<Drawer placement="right" :closable="false" v-model="store_drawer.visible" width="50%">
			<div class="demo-drawer-footer1" style="width:50%">
				<el-button @click="store_drawer.visible=false">关 闭</el-button>
				<el-button @click="saveSheves" type="primary">确定</el-button>
			</div>
			<el-tree style="margin-top:100px" :data="store_drawer.data" :props="store_drawer.props" show-checkbox
				@check="onShelfCheck"></el-tree>
		</Drawer>

		<!-- 盘点详情弹窗 -->
		<Drawer placement="right" :closable="false" :loading="true" v-model="mission_detail.visible" width="50%">
			<div class="demo-drawer-footer1" style="width:50%">
				<el-button @click="mission_detail.visible=false">关 闭</el-button>
			</div>
			<div style="background-color:white;margin-top:55px" v-if="mission_detail.visible">
				<p style="color:#333333;font-size:15px;margin-bottom:6px">
					{{mission_detail.data?mission_detail.data.title:''}}</p>
				<el-row v-if="mission_detail.data" style="color:#999999;font-size:14px">
					<el-col :span="12">{{timeFormatter(mission_detail.data.add_time)}}</el-col>
					<el-col :span="12">创建人:{{mission_detail.data.creator?mission_detail.data.creator.name:''}}</el-col>
				</el-row>
			</div>
			<div style="width:100%;background-color:#F8F8F8;height:8px"></div>
			<div style="background-color:white;padding-top:18px" v-if="mission_detail.visible">
				<el-row>
					<el-col :span="18" style="color:#333333;font-size:15px">盘点区域以及盘点人</el-col>
				</el-row>
				<el-table max-height="650" :data="mission_detail.data.location_configs" row-key="key"
					:default-expand-all="true" :tree-props="mission_detail.props">
					<el-table-column prop="name" label="位置"></el-table-column>
					<el-table-column prop label="初盘人" show-overflow-tooltip>
						<template slot-scope="scope">
							<span v-if="scope.row.type=='shelf' && scope.row.first_checkers ">
								({{scope.row.first_checkers.length+'人：'}}
								<span v-for="(user,ind) in scope.row.first_checkers" :key="ind"
									style="margin-right:5">{{user.user_id?user.name:''}}</span>)
							</span>
						</template>
					</el-table-column>
					<el-table-column prop label="复盘人" show-overflow-tooltip>
						<template slot-scope="scope">
							<span v-if="scope.row.type=='shelf'&& scope.row.last_checkers">
								({{scope.row.last_checkers.length+'人：'}}
								<span v-for="(user,ind) in scope.row.last_checkers" :key="ind"
									style="margin-right:5">{{user.user_id?user.name:''}}</span>)
							</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</Drawer>
		<!-- 选择老师 -->
		<organize-user @selectuser="onUserCheck" ref="organ"></organize-user>
	</section>
</template>
<script>
	import { Drawer } from "iview";
	import { wms_inventory_mission, vms_store } from "@/api/server";
	import organizeUser from "@/components/organizeuser.vue";
	import organize from "@/mixins/organize.js";
	import formatter from "@/mixins/formatter"
	import { mapState } from "vuex";
	import moment from "moment"
	export default {
		mixins: [organize, formatter],
		data() {
			return {
				// 仓库表单
				store_drawer: {
					visible: false,
					data: [],
					props: { children: 'list', label: 'name' },
					selectList: []
				},
				// 任务表单
				mission_form: {
					visible: false,
					saving: false,
					data: {
						title: "",
						configs: [],
						start_time: '',
						end_time: ''
					},
					current_config: null,
					saving: false,
					props: { children: 'list', hasChildren: 'hasChildren' },
					rules: {
						start_time: [
							{ required: true, message: "请选择开始时间", trigger: "change" }
						],
						end_time: [
							{ required: true, message: "请选择截止时间", trigger: "change" }
						],
						title: [
							{ required: true, message: "请填写任务标题", trigger: "change" }
						]
					},
				},
				// 临时的货架配置
				shelf_configs: [],
				//组织架构人员
				maxorganize_list: [],
				// 任务列表
				mission_list: [],
				totalRow: 1,
				filters: {
					page: 1,
					size: 10,
					keyword: null,
					status: null,
				},
				status_config: {
					READY: "未开启",//未开启
					DOING: "正在盘点",//开启，盘点中
					CANCEL: "已经取消",//取消
					COMPLETE: "完成盘点"//完成
				},
				thestatus: [
					{ name: "全部", id: null },
					{ name: "已完成", id: 'COMPLETE' },
					{ name: "未完成", id: 'DOING' },
					{ name: "未开启", id: 'READY' },
					{ name: "已取消", id: 'CANCEL' }
				],
				mission_detail: {
					visible: false,
					data: {},
					loading: false,
					props: { children: 'list', hasChildren: 'hasChildren' },
				},
				selectvisible: false,
				loading: false
			};
		},
		components: {
			Drawer,
			organizeUser
		},
		computed: {
			...mapState("asset", ["sendDetail"]),
		},
		methods: {
			getPrint(data) {
				this.$router.push({ name: 'wmsInventoryPrint', query: { mission_id: data.id } });
			},
			getState(data) {
				this.$router.push({ name: 'wmsInventoryMy', query: { mission_id: data.id } });
			},
			statis(data) {
				this.$router.push({ name: 'wmsInventoryStat', params: { id: data.id } });
			},
			// 创建任务
			create() {
				this.$refs["mission_form"].validate(v => {
					if (v) {
						this.mission_form.data.configs = this.shelf_configs.flatMap(v => v.list).map(o => {
							return {
								"shelf_id": o.shelf_id,
								"store_id": o.store_id,
								"first_checkers": o.isset ? o.first_checkers.map(u => u.user_id) : [],
								"last_checkers": o.isset ? o.last_checkers.map(u => u.user_id) : [],
								"isset": o.isset
							}
						})

						for (let c of this.mission_form.data.configs) {
							if (!c.isset) {
								this.$message({ message: "请设置盘点人员", type: "warning" })
								return;
							}
						}
						this.mission_form.data.start_time = Date.parse(this.mission_form.data.start_time) / 1000
						this.mission_form.data.end_time = Date.parse(this.mission_form.data.end_time) / 1000
						this.mission_form.saving = true
						wms_inventory_mission.create(this.mission_form.data).then(v => {
							this.$message({ message: "任务添加成功", type: "success" })
							this.filters.page = 1
							this.mission_form.visible = false
							this.mission_form.saving = false
							this.getList()

						})

					}
				})

			},
			// 删除任务
			remove(row) {
				this.$confirm("确定要删除?", "提示", {
					confirmButtonText: "删 除",
					cancelButtonText: "取 消",
					type: "warning"
				}).then(() => {
					wms_inventory_mission.remove({ id: row.id }).then(res => {
						if (res.data) {
							this.$message({ message: "删除成功！", type: "success" });
							this.getList()
						}
					});
				}).catch(() => {

				});
			},
			// 开启任务
			start(row) {
				this.$confirm("确定要开启?", "提示", {
					confirmButtonText: "开启",
					cancelButtonText: "取消",
					type: "warning"
				}).then(() => {
					wms_inventory_mission.start({ id: row.id }).then(res => {
						if (res.data) {
							this.$message({ message: "成功开启任务", type: "success" })
							this.getList()
						}
					})
				}).catch(() => {});

			},
			// 取消任务
			cancel(row) {
				this.$confirm("取消后不能再发布，确定要取消?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning"
				}).then(() => {
					wms_inventory_mission.cancel({ id: row.id }).then(res => {
						if (res.data) {
							this.$message({ message: "已经取消了盘点", type: "success" })
							this.getList()
						}
					})
				}).catch(() => {

				});
			},
			// 完成任务
			finish(row) {
				this.$confirm("确定要完成任务?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning"
				}).then(() => {
					wms_inventory_mission.finish({ id: row.id }).then(res => {
						if (res.data) {
							this.$message({ message: "任务完成", type: "success" });
							this.getList();
						}
					});
				});
			},
			// 数据搜索
			search() {
				this.filters.page = 1;
				this.totalRow = 1;
				this.getList();
			},

			nextPage(e) {
				this.filters.page = e;
				this.list = [];
				this.getList();
			},

			// 查看详情
			getDetail(row) {
				this.mission_detail.visible = true
				wms_inventory_mission.get({ id: row.id }).then(res => {
					if (res.data) {
						this.mission_detail.data = res.data
						// this.mission_detail.data.location_configs.map
						let list = []
						for (let v of res.data.location_configs) {
							let store = list.find(s => s.id == v.storehouse.id)
							let o = {
								key: v.storehouse.id + "_" + v.shelf.id,
								name: v.shelf.name,
								first_checkers: v.first_checkers,
								last_checkers: v.last_checkers,
								type: "shelf"
							}
							if (store) {
								store.list.push(o)
							} else {
								v.storehouse.list = [o]
								v.storehouse.key = v.storehouse.id
								list.push(v.storehouse)
							}
						}
						this.mission_detail.data.location_configs = list
					}
				});
			},
			// 获取任务列表
			getList() {
				this.loading = true;
				wms_inventory_mission.paginate(this.filters).then(res => {
					if (res.data) {
						this.mission_list = res.data.list
						this.totalRow = res.data.totalRow
						this.mission_list.map(v => {
							let storeNameList = []
							for (let s of v.location_configs) {
								if (storeNameList.indexOf(s.storehouse.name) == -1) {
									storeNameList.push(s.storehouse.name)
								}
							}
							v.stores = storeNameList.join(",")
							v.start_loading = false
							v.cancel_loading = false
							v.finish_loading = false
							v.remove_loading = false
							return v;
						})
					}
					this.loading = false;
				})
			},
			// 设置审核人
			setChecker(e, val) {
				this.mission_form.current_config = e
				let userList
				if (val == 1) {
					userList = this.maxorganize_list
				} else if (val == 2) {
					userList = e.type == "store" ? userList = e.list[0].pic_users : e.pic_users
				}
				this.mission_form.current_config.step = val == 1 ? "first_checkers" : "last_checkers"
				let select = val == 1 ? e.first_checkers || [] : e.last_checkers || [];
				let select_list = select.map(r => r.id)
				let selectType = val == 2 && this.maxorganize_list.length > 0 ? "nocheck" : "";
				this.$refs.organ.open(userList, select_list, selectType);

			},
			// 选择审核人
			onUserCheck(ids, list) {
				const checkers = list.filter(v => v.type != "father")
				// 如果选择的是仓库的批量设置 
				if (this.mission_form.current_config.type == "store") {
					this.mission_form.current_config.list.forEach(v => {
						v[this.mission_form.current_config.step] = checkers
						if (v.first_checkers && v.first_checkers.length > 0 && v.last_checkers && v.last_checkers.length > 0) {
							v.isset = true
						}
					})
				} else if (this.mission_form.current_config.type == "shelf") { //如果选择的是单个货架
					const shelf = this.mission_form.current_config
					shelf[this.mission_form.current_config.step] = checkers
					if (shelf.first_checkers && shelf.first_checkers.length > 0 && shelf.last_checkers && shelf.last_checkers.length > 0) {
						shelf.isset = true
					}
				}
				const store_id = this.mission_form.current_config.store_id
				const index = this.shelf_configs.findIndex(v => v.store_id == store_id)
				if (index > -1) {
					const store = this.shelf_configs[index]
					this.$set(this.shelf_configs, index, store)
				}
			},
			// 选择货架
			onShelfCheck(a, b) {
				let shelves = b.checkedNodes.filter(v => v.type == "shelf")
				let list = []
				for (let v of shelves) {
					let store = list.find(s => s.store_id == v.store_id)
					v.id = v.store_id + "_" + v.shelf_id
					v.type = "shelf"
					if (store) {
						store.list.push(v)
					} else {
						list.push({
							"id": v.store_id,
							"store_id": v.store_id,
							"name": v.store_name,
							"list": [v],
							"type": "store"
						})
					}
				}
				this.store_drawer.selectList = list
			},
			// 保存选择的货架
			saveSheves() {

				this.shelf_configs = this.store_drawer.selectList;
				this.store_drawer.visible = false
			},



			gostatis(item) {
				this.$router.push({
					path: "/assets/inventory/taskadmin/Statistics?id=" + item.id
				});
			},

			gosend() {
				this.mission_form.data = {
					title: "",
					configs: [],
					start_time: '',
					end_time: ''
				}
				this.shelf_configs = []
				this.mission_form.current_config = null
				this.mission_form.visible = true;
				this.$nextTick(_ => {
					this.$refs.mission_form.clearValidate()
				})
			},



			// 获取仓库列表
			getStorehouseList() {
				vms_store.getList({ "shelf": true, "status": [1] }).then(res => {
					this.store_drawer.data = res.data.map(o => {
						return {
							"name": o.name,
							"store_id": o.id,
							"type": "store",
							"list": o.shelves == null ? null : o.shelves.map(v => {
								return {
									"name": v.name,
									"store_id": o.id,
									"shelf_id": v.id,
									"store_name": o.name,
									"type": "shelf",
									"pic_users": o.pic_user_ids
								}
							})
						}
					})

				})

			},


			statusFormatter(row, column) {
				return row.status ? this.status_config[row.status] : ""
			},
			startEndTimeFormatter(row, column) {
				return moment(row.start_time * 1000).format("YYYY-MM-DD") + "--" + moment(row.end_time * 1000).format("YYYY-MM-DD")
			},
		},
		mounted() {
			this.getStorehouseList()
			this.getList()
			this.getTree().then(res => {
				this.maxorganize_list = res;
			});
		}
	};
</script>
<style lang="scss" scoped>
	section {
		padding: 20px 0;
	}
</style>


// WEBPACK FOOTER //
// src/views/warehouse/inventory/index.vue